import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { categoryColors } from '../../theme';

export interface Category {
  id: string;
  name: string;
  color: string;
}

interface CategoriesState {
  categories: Category[];
}

const initialState: CategoriesState = {
  categories: [
    { id: uuidv4(), name: 'Infrastructure', color: categoryColors[0] },
    { id: uuidv4(), name: 'Feature', color: categoryColors[1] },
    { id: uuidv4(), name: 'Bug Fix', color: categoryColors[2] },
  ],
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    addCategory: (state, action: PayloadAction<{ name: string; color?: string }>) => {
      const color = action.payload.color ?? categoryColors[state.categories.length % categoryColors.length];
      state.categories.push({ id: uuidv4(), name: action.payload.name, color });
    },
    updateCategory: (state, action: PayloadAction<{ id: string; name: string; color: string }>) => {
      const cat = state.categories.find(c => c.id === action.payload.id);
      if (cat) {
        cat.name = action.payload.name;
        cat.color = action.payload.color;
      }
    },
    removeCategory: (state, action: PayloadAction<string>) => {
      state.categories = state.categories.filter(c => c.id !== action.payload);
    },
    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.categories = action.payload;
    },
  },
});

export const { addCategory, updateCategory, removeCategory, setCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
